export default __webpack_public_path__ + "static/media/janseencilag.dc729266.svg";